export class InformationMessageError {
    status: boolean;
    statusCode: number;
    intlCode: number
    errorType: string;
    statusInfo: string;
    internalMessage: string;
    constructor(intlCode: number, statusInfo: string) {
        this.status = false;
        this.statusCode = 10000;
        this.intlCode = intlCode;
        this.errorType = 'Information Message';
        this.statusInfo = statusInfo;
        this.internalMessage = statusInfo;
    }
}